import React from 'react';

import { Box, Button, Text } from 'grommet';
import { LogoBlack } from '@/components/logo/logo';
import { useViewerContext } from '@/contexts/useViewer';

const NoSessionScreen = () => {
  const { handleLogout } = useViewerContext();
  return (
		<Box flex align="center" justify="center" height="100vh" gap="medium">
			<Box width="300px">
				<LogoBlack />
			</Box>
			<Text
				color="red"
				weight="bold"
				style={{ width: '60%' }}
				textAlign="center"
			>
				Oops! you seem to be disconnected from the session, please refresh the
				page to try again
			</Text>
			<Box margin={{ top: '15px' }} gap="small">
				<Button
					primary
					size="medium"
					onClick={() => window.location.reload()}
					label="Refresh page"
				/>
				<Button
					secondary
					size="medium"
					onClick={handleLogout}
					label="Log out"
				/>
			</Box>
		</Box>
	);
}

export default NoSessionScreen